import { useTranslation } from "react-i18next";
import { AllFeaturesHero } from "~/components/products/all-features/AllFeaturesHero";
import { AllFeaturesBody } from "~/components/products/all-features/AllFeaturesBody";
import { FleetIntegrations } from "~/components/fleet/FleetIntegrations";
import { FleetLastChance } from "~/components/fleet/FleetLastChance";
import { FLEET_ALL_FEATURES } from "~/data/fleet-all-features";

export const handle = {
  headerMode: "fleet",
  footerMode: "fleet",
  pageTheme: "fleet",
  sitemap: { title: "Bouncie Fleet — All Features" },
};

export default function FleetFeatures() {
  const { t } = useTranslation("fleet");
  const content = FLEET_ALL_FEATURES;

  return (
    <>
      <title>{t(content.metaTitle)}</title>
      <meta name="description" content={t(content.metaDescription)} />
      {/* The all-features components restyle themselves for the dark fleet tokens via fleet: variants. */}
      <div className="fleet bg-background text-text-body">
        <AllFeaturesHero headline={content.headline} description={content.description} />
        <AllFeaturesBody
          categories={content.categories}
          featureDetailsHeading={content.featureDetailsHeading}
          expandAllLabel={content.expandAllLabel}
          collapseAllLabel={content.collapseAllLabel}
        />
        <FleetIntegrations />
        <FleetLastChance />
      </div>
    </>
  );
}
